import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_URL || 'https://undo-backend.duckdns.org';
export const WS_URL = process.env.REACT_APP_WS_URL || 'wss://undo-backend.duckdns.org';

// For local development - Backend running on your machine
// export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
// export const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8000';

const api = axios.create({ baseURL: `${BASE_URL}/api` });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.replace('/login');
    }
    return Promise.reject(err);
  }
);

// Helper: make any URL absolute
export function resolveUrl(url) {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return BASE_URL.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
}

export default api;
